import React, { useState, useEffect } from 'react';
import Axios from 'axios';

import ProgressIndicator from '../Common/ProgressIndicator';
import ErrorIndicator from '../Common/ErrorIndicator';
import SelectFieldGroup from '../Common/SelectFieldGroup';

function DataTable(props) {
    const [response, setResponse] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);

    const [selectedIds, setSelectedIds] = useState([]);

    const paginationArray = response ? [...Array(response.pages).keys().toArray().slice(page - 5, page + 5)] : [];

    useEffect(() => {
        setIsLoading(true);
        //reactTableDataToUrl(props.url, state)
        Axios.get(`${props.url}?page=${page}&pageSize=${pageSize}`).then(res => {
            setResponse(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [page, pageSize, props.url]);


    const changeSelection = (id) => {
        /*if (selectedIds.includes(id)) {
            setSelectedIds(selectedIds.filter(i => i !== id))
        } else {
            setSelectedIds([...selectedIds, id])
        }
        if (props.onSelectionChange) {
            props.onSelectionChange(selectedIds)
        }*/
    }

    if (isLoading)
        return <ProgressIndicator />;

    if (error === true)
        return <ErrorIndicator text={props.errorMessage} />;

    if (!response || response.data.length === 0) {
        return <p>
            <em>Nincs megjeleníthető adat.</em>
        </p>
    }

    return (
        <>
            <table className="table table-hover">
                <thead>
                    <tr className="bg-transparent fw-bold">
                        <td>Kijelölés</td>
                        {props.columns.map((col, index) => <td key={index}>{col.header}</td>)}
                    </tr>
                </thead>
                <tbody>
                    {
                        response.data.map(row => 
                            <tr className="bg-transparent" key={row.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedIds.includes(row.id)}
                                        onChange={changeSelection(row.id)}
                                    />
                                </td>
                                {props.columns.map((col, index) => <td key={index}>
                                    {col.cell && col.cell(col.accessor ? row[col.accessor] : row)}
                                    {!col.cell && row[col.accessor]}
                                </td>)}
                            </tr>
                        )
                    }
                </tbody>
            </table>
            <div className="d-flex flex-row justify-content-center gap-2">
                    <button type="button" className="btn btn-primary" onClick={e => setPage(0)}>Első</button>
                    {
                        paginationArray.map(i => <button type="button" className={`btn btn-${page === i ? 'secondary' : 'primary'}`} key={i} onClick={e => setPage(i)}>
                            {i + 1}
                        </button>)
                    }
                    <button type="button" className="btn btn-primary" onClick={e => setPage(response.pages - 1)}>Utolsó</button>
            </div>
            <div className="d-flex flex-row gap-3">
                <SelectFieldGroup
                    field="pageSize"
                    onChange={e => setPageSize(e.target.value)}
                    label="Oldalméret"
                    value={pageSize}
                >
                    {
                        [10, 20, 50, 100].map(i => <option value={i} key={i}>
                            {i}
                        </option>)
                    }
                    </SelectFieldGroup>
            </div>
        </>
    );
}

export default DataTable;
